export default "__VITE_ASSET__CG1buw6___"